//auth
export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const LOGIN_CHECKED = 'login_checked';
